import React from 'react';
import { AwardIcon, DropletIcon, CoffeeIcon } from 'lucide-react';
import { Language, translations } from '../utils/translations';
export function Advantages({
  lang
}: {
  lang: Language;
}) {
  const t = translations[lang];
  return <section data-id="element-27" data-mp="3hahfpsci1uxs">
      <h2 className="mb-5 text-center text-[19px] font-bold tracking-[-0.03em] text-zinc-50" data-id="element-28" data-mp="3ha7z2vdch04r">
        {t.advantagesTitle}
      </h2>
      <ul className="grid gap-3" data-id="element-29" data-mp="2om2fwd1xvj71">
        <li className="flex items-center gap-3.5 rounded-2xl bg-zinc-900 p-4" data-id="element-30" data-mp="2ondhq7btqgvi">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-zinc-800 text-gold-500" data-id="element-31" data-mp="2jnr2jscfqqk2">
            <AwardIcon className="h-5 w-5" data-id="element-32" data-mp="2yd6qz1ohujwl" />
          </span>
          <div className="flex flex-col text-left" data-id="element-33" data-mp="2tlosqlduuxfb">
            <h3 className="text-[15px] font-bold text-zinc-100" data-id="element-34" data-mp="2tju7t72l35b8">{t.adv1Title}</h3>
            <p className="mt-1 text-[13px] text-zinc-400" data-id="element-35" data-mp="25usup6it35zm">{t.adv1Desc}</p>
          </div>
        </li>
        <li className="flex items-center gap-3.5 rounded-2xl bg-zinc-900 p-4" data-id="element-36" data-mp="20vpvw3tf5w03">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-zinc-800 text-gold-500" data-id="element-37" data-mp="3go1xdg6gpr3r">
            <DropletIcon className="h-5 w-5" data-id="element-38" data-mp="3ll23ts784vve" />
          </span>
          <div className="flex flex-col text-left" data-id="element-39" data-mp="3qdbr10gyfhtz">
            <h3 className="text-[15px] font-bold text-zinc-100" data-id="element-40" data-mp="3qdldwf6pd8vg">{t.adv2Title}</h3>
            <p className="mt-1 text-[13px] text-zinc-400" data-id="element-41" data-mp="3uddh0cdbumtf">{t.adv2Desc}</p>
          </div>
        </li>
        <li className="flex items-center gap-3.5 rounded-2xl bg-zinc-900 p-4" data-id="element-42" data-mp="2xpplvns2w550">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-zinc-800 text-gold-500" data-id="element-43" data-mp="32mpil831fvjg">
            <CoffeeIcon className="h-5 w-5" data-id="element-44" data-mp="36ob39fltde47" />
          </span>
          <div className="flex flex-col text-left" data-id="element-45" data-mp="3bnxhnsddp0el">
            <h3 className="text-[15px] font-bold text-zinc-100" data-id="element-46" data-mp="3bpgwdejdz3e9">{t.adv3Title}</h3>
            <p className="mt-1 text-[13px] text-zinc-400" data-id="element-47" data-mp="ly26hlvgn3xh">{t.adv3Desc}</p>
          </div>
        </li>
      </ul>
    </section>;
}